import { createFileRoute } from '@tanstack/react-router'
import { requirePermissionList } from '@/utils/auth'

export const Route = createFileRoute('/route-planner/$areaId/$routeId/$version')({
  beforeLoad: () => requirePermissionList(['maps', 'routes']),
  component: () => null,
})
